<template>
  <div class="box">
    <Card>
      <div slot="title" style="overflow: hidden;">
        <h1 style="float:left;">万里出行汽车票查询</h1>
        <Button type="primary" style="float:right;" @click="go_back">返回</Button>
      </div>

      <Row class="search_box" :gutter="30">
        <Col style="display:flex;" :xs="24" :sm="12" :md="8" :lg="5">
          <div style="width:30%;line-height:32px;">
            <Icon type="md-bus" size="20" />&nbsp;出发:
          </div>
          <Select
            v-model="start"
            @on-change="start_select"
            filterable
            style="width:82%;"
            label-in-value
            placeholder="请选择出发地"
          >
            <Option
              v-for="(item,id) in cityList"
              :value="item.label"
              :key="item.id"
            >{{ item.value | endVal_select }}</Option>
          </Select>
        </Col>

        <Col style="display:flex;" :xs="24" :sm="12" :md="8" :lg="5">
          <div style="width:30%;line-height:32px;">
            <Icon type="md-bus" size="20" />&nbsp;到达:
          </div>
          <Select
            v-model="end"
            filterable
            placeholder="请选择到达地"
            @on-change="end_select"
            style="width:82%;"
            label-in-value
          >
            <Option
              v-for="(item,id) in endList"
              :value="item.label"
              :key="item.id"
            >{{ item.value | endVal_select }}</Option>
          </Select>
        </Col>

        <Col :xs="24" :sm="12" :md="8" :lg="5">
          <div style="display:flex;">
            <div style="width:30%;line-height:32px;">
              <Icon type="ios-time-outline" size="20" />&nbsp;日期:
            </div>
            <DatePicker
              @on-change="date_onChange"
              :value="date"
              format="yyyy-MM-dd"
              type="date"
              placeholder="请选择日期"
              style="width:82%;"
            ></DatePicker>
          </div>
        </Col>

        <Col :xs="24" :sm="12" :md="8" :lg="5">
          <Button type="primary" @click="btn_inquire">查询</Button>
        </Col>
      </Row>
      <Row class="search_box" :gutter="30">
        <Col :span="24" :xs="24" :sm="24" :md="24" :lg="24">
          <div class="tabs_box">
            <ButtonGroup style="width:100%;">
              <Button
                v-for="(item,id) in dateList"
                :key="item.id"
                class="date_btn"
                :type="id==data_indx?'primary':'default'"
                @click="date_btn(item,id)"
              >{{item}}</Button>
            </ButtonGroup>
          </div>
        </Col>
        <Col :span="24">
          <Table :columns="columns1" :data="data1">
            <template slot-scope="{ row, index }" slot="action">
              <Button size="small" @click="buy" type="warning">购票</Button>
            </template>
          </Table>
        </Col>
      </Row>
    </Card>

    <!-- 公众号二维码 -->
    <Modal v-model="modal" class-name="vertical-center-modal">
      <div style=" padding:2px;margin:auto;
      width:210px; border: 1px solid #ccc;">
        <img style="width:200px;" src="../assets/20200414153110.jpg" alt />
      </div>
      <h2 slot="header">请关注万里出行公众号进行购票！</h2>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import { getAllStart, getAllStop, getBusInfoStop } from "../api/index.js";
var columns1 = [
  {
    title: "班次",
    key: "fstartBc",
    render: (h, params) => {
      return h("div", [
        h(
          "span",
          {
            style: {
              fontSize: "20px"
              // fontWeight: 700
            }
          },
          params.row.fstartBc
        )
      ]);
    }
  },

  {
    title: "发车时间",
    key: "fstartTime",

    render: (h, params) => {
      return h("div", [
        h("icon", {
          props: {
            type: "ios-time-outline",
            color: "#515a6e",
            size: 23
          }
        }),
        h(
          "span",
          {
            style: {
              fontSize: "20px"
            }
          },
          params.row.fstartTime
        )
      ]);
    }
  },
  {
    title: "线路",
    key: "fstartStationName+fstopStationName",
    render: (h, params) => {
      return h("div", [
        h(
          "span",
          {
            style: {
              fontSize: "18px"
              // fontWeight: 700
            }
          },
          params.row.fstartStationName + "    "
        ),

        h("icon", {
          props: {
            type: "md-arrow-forward",
            color: "#F60",
            size: 20
          }
        }),

        h(
          "span",
          {
            style: {
              fontSize: "18px"
              // fontWeight: 700
            }
          },
          "    " + params.row.fstopStationName
        )
      ]);
    }
  },
  {
    title: "余座",
    key: "fseatAmount",
    render: (h, params) => {
      // if (params.row.fseatAmount.length == 1) {
      //   return h("div", [
      //     h(
      //       "span",
      //       {
      //         style: {
      //           fontSize: "20px"
      //         }
      //       },
      //       "0" + params.row.fseatAmount
      //     )
      //   ]);
      // } else {
      return h("div", [
        h(
          "span",
          {
            style: {
              fontSize: "20px"
            }
          },
          params.row.fseatAmount
        )
      ]);
      // }
    }
  },
  {
    title: "票价",
    key: "ffullPrice",
    render: (h, params) => {
      return h("div", [
        h("icon", {
          props: {
            type: "logo-yen",
            color: "#FF0000",
            size: 16
          }
        }),
        h(
          "span",
          {
            style: {
              fontSize: "20px"
            }
          },
          params.row.ffullPrice
        )
      ]);
    }
  },
  {
    title: "车型",
    key: "fbusTypeName",

    render: (h, params) => {
      return h("div", [
        h(
          "span",
          {
            style: {
              fontSize: "20px"
              // fontWeight: 600
            }
          },
          params.row.fbusTypeName
        )
      ]);
    }
  },
  {
    title: "购票",
    slot: "action",
    width: 150,
    align: "center"
  }
];
var data1 = [];
export default {
  data() {
    return {
      columns1,
      data1,
      cityList: [],
      endList: [],
      start: "",
      end: "",
      date: "",
      fstartStationCode: "",
      fstopStationCode: "",
      dateList: [],
      data_indx: 0,
      modal: false
    };
  },
  mounted() {
    //初始化 出发-到达地 下拉框
    this.getStart();
    this.getend();
    //处理query传过来的值
    this.date = JSON.parse(this.$route.query.obj).date;
    this.start = JSON.parse(this.$route.query.obj).start.value;
    this.end = JSON.parse(this.$route.query.obj).end.value;
    this.fstartStationCode = JSON.parse(
      this.$route.query.obj
    ).start.value.split("&")[0];
    this.fstopStationCode = JSON.parse(this.$route.query.obj).end.value.split(
      "&"
    )[0];
    //默认查询query传值
    this.inquire(this.fstartStationCode, this.fstopStationCode, this.date);
    //遍历后几天按钮日期
    for (let i = 0; i < 12; i++) {
      this.dateList.push(this.GetDateStr(i));
    }
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route(to, from) {
      if (to.name == "Index") {
        // console.log("监听路由变化");
        //处理query传的值，按钮下标初始化
        this.data_indx = 0;
        this.date = JSON.parse(this.$route.query.obj).date;
        this.start = JSON.parse(this.$route.query.obj).start.value;
        this.end = JSON.parse(this.$route.query.obj).end.value;
        this.fstartStationCode = JSON.parse(
          this.$route.query.obj
        ).start.value.split("&")[0];
        this.fstopStationCode = JSON.parse(
          this.$route.query.obj
        ).end.value.split("&")[0];
        //查询数据
        this.inquire(this.fstartStationCode, this.fstopStationCode, this.date);
      }
    }
  },
  filters: {
    //下拉框 过滤器 过滤车站字母 郑州：zz
    endVal_select(val) {
      var reg = /[a-zA-Z]*/g;
      var result = val.replace(reg, "");
      return result;
    }
  },
  methods: {
    date_onChange(date) {
      this.date = date;
    },
    //出发下拉 分割取车站的fstartStationCode
    start_select(obj) {
      if (obj == undefined) {
        return false;
      }

      this.start = obj.value;
      console.log(obj);
      let new_val = obj.value.split("&")[0];
      this.fstartStationCode = new_val;
    },
    //到达下拉 分割取车站的fstopStationCode
    end_select(obj) {
      if (obj == undefined) {
        return false;
      }

      this.end = obj.value;
      let new_val = obj.value.split("&")[0];
      this.fstopStationCode = new_val;
    },
    go_back() {
      this.$router.push("/");
    },
    getStart() {
      let msg = {
        backMsgId: "1009002000",
        backSerId: 0,
        key: 0,
        msgBody: {},
        msgId: "1009002001",
        msgSta: 1,
        respType: 0,
        serId: 0,
        source: 0
      };

      getAllStart({ data: msg })
        .then(res => {
          this.cityList = [];
          //遍历pageObjBody，把value拼接成"车站名"和"车站字母";label拼接成车站的"code"和"车站字母"
          for (let i = 0; i < res.msgBody.pageOutBody.pageObjBody.length; i++) {
            this.cityList.push({
              value:
                res.msgBody.pageOutBody.pageObjBody[i].fstationName +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy,
              label:
                res.msgBody.pageOutBody.pageObjBody[i].fstationCode +
                "&" +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getend() {
      let msg = {
        backMsgId: "1009002003",
        backSerId: 0,
        key: 0,
        msgBody: {},
        msgId: "1009002002",
        msgSta: 1,
        respType: 0,
        serId: 0,
        source: 0
      };

      getAllStop({ data: msg })
        .then(res => {
          this.endList = [];

          //遍历pageObjBody，把value拼接成"车站名"和"车站字母";label拼接成车站的"code"和"车站字母"
          for (let i = 0; i < res.msgBody.pageOutBody.pageObjBody.length; i++) {
            this.endList.push({
              value:
                res.msgBody.pageOutBody.pageObjBody[i].fstationName +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy,
              label:
                res.msgBody.pageOutBody.pageObjBody[i].fstationCode +
                "&" +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    GetDateStr(AddDayCount) {
      if (AddDayCount == undefined) {
        AddDayCount = 0;
      }
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var days = dd.getDay();
      switch (days) {
        case 1:
          days = "周一";
          break;
        case 2:
          days = "周二";
          break;
        case 3:
          days = "周三";
          break;
        case 4:
          days = "周四";
          break;
        case 5:
          days = "周五";
          break;
        case 6:
          days = "周六";
          break;
        case 0:
          days = "周日";
          break;
      }
      return m + "/" + d + " " + days;
    },
    inquire(start, end, date) {
      // console.log("查询");
      let msg = {
        backMsgId: "1009002005",
        backSerId: 0,
        key: 0,
        msgBody: {
          fstartStationCode: start,
          fstopStationCode: end,
          fstartDate: date,
          fstartDqSuid: "",
          fendDqSuid: "",
          pageSetBody: {
            pageNo: 0,
            pageSize: 100
          }
        },
        msgId: "1009002004",
        msgSta: 1,
        respType: 0,
        serId: 0,
        source: 0
      };

      getBusInfoStop({ data: msg })
        .then(res => {
          this.data1 = [];

          if (JSON.stringify(res.msgBody) != "{}") {
            // for(var i=0;i<100;i++){
            //    this.data1.push(res.msgBody.pageOutBody.pageObjBody[0]);
            // }

            this.data1 = res.msgBody.pageOutBody.pageObjBody;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    btn_inquire() {
      this.inquire(this.fstartStationCode, this.fstopStationCode, this.date);
    },
    date_btn(txt, id) {
      this.data_indx = id;
      let month_day = txt.split(" ")[0];
      let new_date =
        this.date.split("-")[0] +
        "-" +
        month_day.split("/")[0] +
        "-" +
        month_day.split("/")[1];

      this.inquire(this.fstartStationCode, this.fstopStationCode, new_date);
    },
    buy() {
      this.modal = true;
    }
  },
  components: {}
};
</script>

<style scoped>
.box {
  min-height: 70%;
  background: url("../assets/banner_02.png");
  background-size: 100% 100%;
  padding: 30px;
}
.search_box {
  padding: 30px 20px;
}
.date_btn {
  float: left;
  height: auto;
  font-size: 18px;
  padding: 1% 1.7%;
}

>>> .ivu-table-header thead tr th {
  padding: 15px 0;
  font-size: 25px;
}
>>> .ivu-modal-body {
  height: 270px;
  padding: 25px;
}
/* >>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 10%;
} */
>>> .ivu-modal-footer {
  display: none;
}
>>> .ivu-modal {
  width: 360px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue